import React, { useEffect } from "react";
import { Pagination} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getLeaveList } from "../../../../redux/leave/leaveState";
import { DATE_FORMAT } from "variables/constants";
import LeaveCard from "./LeaveCard";
import { displayIcon } from "variables/icons";

const LeaveTable = ({ 
  dateRange,
}) => {

    const dispatch = useDispatch();

    const recordList = useSelector((state) => state.leave.leaveList?.items);
    const pagination = useSelector((state) => state.leave.leaveList?.pagination);
    const filters = useSelector((state) => state.leave.leaveList?.filters);

    const doSearch = (filters) => dispatch(getLeaveList(filters));


  useEffect(() => {
    const filters = {
      paginate: pagination.per_page,
    };

    if (dateRange?.length === 2) {
      filters.date_from = dateRange[0].format(DATE_FORMAT);
      filters.date_to = dateRange[1].format((DATE_FORMAT));
    }

    dispatch(getLeaveList(filters));
  }, [dispatch, pagination.per_page, dateRange]);

  return (
    <>    
      <div className="overflow-y-auto pr-2">
        {recordList?.length > 0 ? (
          <LeaveCard recordList={recordList} />
        ) : (
          <div className="py-10 flex flex-col items-center justify-center text-gray-400">
            {displayIcon('CalendarX', "w-10 h-10 mb-3")}
            <span className="text-sm">
              No leave records found
            </span>
        </div>
        )}
      </div>
      {pagination?.total > pagination?.per_page && (
        <div className="flex justify-end py-4">
          <Pagination
            current={pagination?.current_page}
            pageSize={pagination?.per_page}
            total={pagination?.total}
            showSizeChanger={false}
            onChange={(page) =>
              doSearch({
                ...filters,
                page,
                paginate: pagination?.per_page,
              })
            }
          />
        </div>
      )}
    </>

  );
};

export default (LeaveTable);
